<template>
  <div>
    <card>
        <h1>CHECK LIST ANALISI INIZIALE ORGANIZZAZIONE E GESTIONE DELLA SALUTE E SICUREZZA SUL LAVORO</h1>
        <b-card no-body>
            <b-tabs pills card v-model="tabIndex">
                <b-tab title="Tab 1" :title-link-class="linkClass(0)" active>
                    <b-card-text>
                        <h2>ANAGRAFICA AZIENDALE</h2>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="data">Data<span style="color:#ff0000">*</span></label>
                                <input type="date" class="form-control" v-model="data">
                            </div>
                            <div class="form-group col-md-6">
                                <label for="ditta">Ditta<span style="color:#ff0000">*</span></label>
                                <input type="text" class="form-control" v-model="ditta">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-4">
                                <label for="n_sedi">N. Sedi<span style="color:#ff0000">*</span></label>
                                <input type="number" class="form-control" v-model="n_sedi">
                            </div>
                            <div class="form-group col-md-4">
                                <label for="sede_operativa">1. Sede operativa<span style="color:#ff0000">*</span></label>
                                <input type="text" class="form-control" v-model="sede_operativa">
                            </div>
                            <div class="form-group col-md-4">
                                <label for="sede_legale">2. Sede legale (se diversa)</label>
                                <input type="text" class="form-control" v-model="sede_legale">
                            </div>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-2">
                                <label for="n_soci">N. Soci<span style="color:#ff0000">*</span></label>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="n_soci_lavoratori">di cui lavoratori<span style="color:#ff0000">*</span></label>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="n_dipendenti">N. dipendenti<span style="color:#ff0000">*</span></label>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="n_collaboratori">N. collaboratori<span style="color:#ff0000">*</span></label>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="subapp">Subapp.<span style="color:#ff0000">*</span></label>
                            </div>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-2">
                                <input type="number" class="form-control" v-model="n_soci">
                            </div>
                            <div class="form-group col-md-2">
                                <input type="number" class="form-control" v-model="n_soci_lavoratori">
                            </div>
                            <div class="form-group col-md-2">
                                <input type="number" class="form-control" v-model="n_dipendenti">
                            </div>
                            <div class="form-group col-md-2">
                                <input type="number" class="form-control" v-model="n_collaboratori">
                            </div>
                            <div class="form-group col-md-2">
                                <input type="number" class="form-control" v-model="subapp">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="interferenze">Interferenze (art. 26)<span style="color:#ff0000">*</span></label>
                                <!-- <input type="text" class="form-control" v-model="interferenze"> -->
                                <textarea lass="form-control" v-model="interferenze" rows="3" style="width:100%;border-radius:7px"></textarea>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="descrizione_attivita">Descrizione attività<span style="color:#ff0000">*</span></label>
                                <textarea lass="form-control" v-model="descrizione_attivita" rows="3" style="width:100%;border-radius:7px"></textarea>
                            </div>
                        </div>
                        <h3>Orario di lavoro</h3>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-4">
                                <label for="n_ore_settimanali">N° ore settimanali<span style="color:#ff0000">*</span></label>
                                <input type="number" class="form-control" v-model="n_ore_settimanali">
                            </div>
                            <div class="form-group col-md-4">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Orario Notturno</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="orario_notturno"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2" v-if="orario_notturno">
                                <label for="orario_dalle">Dalle<span style="color:#ff0000">*</span></label>
                                <input type="time" class="form-control" v-model="orario_dalle">
                            </div>
                            <div class="form-group col-md-2" v-if="orario_notturno">
                                <label for="orario_alle">Alle<span style="color:#ff0000">*</span></label>
                                <input type="time" class="form-control" v-model="orario_alle">
                            </div>
                        </div>
                         <div class="form-row">
                            <div class="form-group col-md">
                                <label for="mansioni_dipendenti">Mansioni dipendenti<span style="color:#ff0000">*</span></label>
                                <textarea lass="form-control" v-model="mansioni_dipendenti" rows="3" style="width:100%;border-radius:7px"></textarea>
                            </div>
                        </div>
                         <div class="form-row">
                            <div class="form-group col-md">
                                <label for="note">Note</label>
                                <textarea lass="form-control" v-model="note" rows="3" style="width:100%;border-radius:7px"></textarea>
                            </div>
                        </div>
                        <button v-on:click="tabIndex = 1" class="btn">Avanti</button>
                    </b-card-text>
                </b-tab>
                <b-tab title="Tab 2" :title-link-class="linkClass(1)">
                    <b-card-text>
                        <h2>ORGANIGRAMMA DEL SERVIZIO DI PREVENZIONE E PROTEZIONE</h2>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-6">
                                <label for="datore_lavoro">Datore di lavoro/delegato alla sicurezza<span style="color:#ff0000">*</span></label>
                                <input type="text" class="form-control" v-model="datore_lavoro">
                            </div>
                            <div class="form-group col-md-2">
                                <label for="delegato_sicurezza">Delegato alla sicurezza<input type="checkbox" class="form-control" v-model="delegato_sicurezza"></label>
                            </div>
                            <div class="form-group col-md-4" v-if="delegato_sicurezza">
                                <label for="data_delegato_sicurezza">Indicare la data della delega</label>
                                <input type="date" class="form-control" v-model="data_delegato_sicurezza">
                            </div>
                        </div>
                        <h3>RSPP</h3>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-6">
                                <label for="rspp_sig">Sig.</label>
                                <input type="text" class="form-control" v-model="rspp_sig">
                            </div>
                            <div class="form-group col-md-2">
                                <label for="rspp_dl">RSPP DL<input type="checkbox" class="form-control" v-model="rspp_dl"></label>
                            </div>
                        </div>
                        <h3 style="margin-top:10px">MEDICO COMPETENTE</h3>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-3">
                                <label for="medico_competente_dr">DR</label>
                                <input type="text" class="form-control" v-model="medico_competente_dr">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="medico_non_nominato">Non nominato</label>
                                <input type="radio" class="form-control" value="medico_non_nominato" v-model="medico_non_nominato">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="medico_da_nominare">Da nominare</label>
                                <input type="radio" class="form-control" value="medico_da_nominare" v-model="medico_da_nominare">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="medico_in_fase_nomina">In fase di nomina</label>
                                <input type="radio" class="form-control" value="medico_in_fase_nomina" v-model="medico_in_fase_nomina">
                            </div>
                        </div>
                        <h3 style="margin-top:10px">RLS o RLST</h3>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-3">
                                <label for="rls_sig">Sig.</label>
                                <input type="text" class="form-control" value="rls_sig" v-model="rls_sig">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="rls_non_nominato">Non nominato</label>
                                <input type="radio" class="form-control" value="rls_non_nominato" v-model="rls_non_nominato">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="rls_da_nominare">Da nominare</label>
                                <input type="radio" class="form-control" value="rls_da_nominare" v-model="rls_da_nominare">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="rls_in_fase_nomina">In fase di nomina</label>
                                <input type="radio" class="form-control" value="rls_in_fase_nomina" v-model="rls_in_fase_nomina">
                            </div>
                        </div>
                        <h3 style="margin-top:10px">ADDETO PRIMO SOCCORSO*</h3>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-6">
                                <label for="soccorso_sig1">Sig.</label>
                                <input type="text" class="form-control" value="soccorso_sig1" v-model="soccorso_sig1">
                            </div>
                             <div class="form-group col-md-6">
                                <label for="soccorso_nomina_del1">Nomina del</label>
                                <input type="date" class="form-control" value="soccorso_nomina_del1" v-model="soccorso_nomina_del1">
                            </div>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-6">
                                <label for="soccorso_sig2">Sig.</label>
                                <input type="text" class="form-control" value="soccorso_sig2" v-model="soccorso_sig2">
                            </div>
                             <div class="form-group col-md-6">
                                <label for="soccorso_nomina_del2">Nomina del</label>
                                <input type="date" class="form-control" value="soccorso_nomina_del2" v-model="soccorso_nomina_del2">
                            </div>
                        </div>
                        <h3 style="margin-top:10px">ADDETO ANTINCENDIO*</h3>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-6">
                                <label for="antincendio_sig1">Sig.</label>
                                <input type="text" class="form-control" value="antincendio_sig1" v-model="antincendio_sig1">
                            </div>
                             <div class="form-group col-md-6">
                                <label for="antincendio_nomina_del1">Nomina del</label>
                                <input type="date" class="form-control" value="antincendio_nomina_del1" v-model="antincendio_nomina_del1">
                            </div>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-6">
                                <label for="antincendio_sig2">Sig.</label>
                                <input type="text" class="form-control" value="antincendio_sig2" v-model="antincendio_sig2">
                            </div>
                             <div class="form-group col-md-6">
                                <label for="antincendio_nomina_del2">Nomina del</label>
                                <input type="date" class="form-control" value="antincendio_nomina_del2" v-model="antincendio_nomina_del2">
                            </div>
                        </div>
                        <h3 style="margin-top:10px">PREPOSTO</h3>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-6">
                                <label for="preposto_sig">Sig.</label>
                                <input type="text" class="form-control" value="preposto_sig" v-model="preposto_sig">
                            </div>
                             <div class="form-group col-md-6">
                                <label for="preposto_nomina_del">Nomina del</label>
                                <input type="date" class="form-control" value="preposto_nomina_del" v-model="preposto_nomina_del">
                            </div>
                        </div>
                        <div style="text-align:left; margin-top:15px">
                           Legenda
                            <ul>
                                <li>Non nominato: il DL non intende procedere con la procedura di nomina.</li>
                                <li>Da nominare: il DL procederà in seguito con la procedura di nomina.</li>
                                <li>In fase di nomina: il DL ha già iniziato la procedura ma non ha ancora concluso l’iter.</li>
                            </ul>
                        </div>
                        <button v-on:click="tabIndex = 2" class="btn">Avanti</button>
                    </b-card-text>
                </b-tab>
                <b-tab title="Tab 3" :title-link-class="linkClass(2)">
                    <b-card-text>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-2">
                                <label>DVR Documento di valutazione dei rischi<br>(D.lgs. 81/08)</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="dvr_evidenza"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="dvr_data_redazione">Data redazione</label>
                                <input type="date" class="form-control" v-model="dvr_data_redazione">
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Predisporre</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="dvr_predisporre"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                <label>L’autocertificazione vale fino a giugno 2013.</label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-2">
                                <label>POS (D.lgs. 81/08, titolo IV): solo verifica del modello utilizzato</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="pos_evidenza"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="pos_data_redazione">Data redazione</label>
                                <input type="date" class="form-control" v-model="pos_data_redazione">
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Predisporre</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="pos_predisporre"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                <label></label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-2">
                                <label>DUVRI (D.lgs. 81/08, titolo IV): (lavori eseguiti in azienda da ditte esterne)</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="duvri_evidenza"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="duvri_data_redazione">Data redazione</label>
                                <input type="date" class="form-control" v-model="duvri_data_redazione">
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Predisporre</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="duvri_predisporre"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                <label></label>
                            </div>
                        </div>

                        <h3>Documenti id valutazione dei <b>rischi specifici</b> (possono essere contenuti o allegati al DVR, POS)</h3>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-2">
                                <label>Tipologia del rischio: Chimico</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="chimico_evidenza"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="chimico_data_redazione">Data redazione</label>
                                <input type="date" class="form-control" v-model="chimico_data_redazione">
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Predisporre</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="chimico_predisporre"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                <label>Note: Aggiornamento periodico</label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-2">
                                <label>Tipologia del rischio: Stress lavoro correlato</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="stress_evidenza"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="stress_data_redazione">Data redazione</label>
                                <input type="date" class="form-control" v-model="stress_data_redazione">
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Predisporre</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="stress_predisporre"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                <label>Note: Rischio basso: agg. 2 anni<br>Rischio medio: agg. 1 anni</label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-2">
                                <label>Tipologia del rischio: Incendio</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="incendio_evidenza"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="incendio_data_redazione">Data redazione</label>
                                <input type="date" class="form-control" v-model="incendio_data_redazione">
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Predisporre</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="incendio_predisporre"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                <label>Note: Rischio basso: agg. 2 anni<br>Rischio medio: agg. 1 anni</label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-2">
                                <label>Tipologia del rischio: ATEX (centrale termica, forni, ricarica batteria carrelli, depositi infiammabili)</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="atex_evidenza"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="atex_data_redazione">Data redazione</label>
                                <input type="date" class="form-control" v-model="atex_data_redazione">
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Predisporre</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="atex_predisporre"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                <label>Note: Rischio basso: agg. 2 anni<br>Rischio medio: agg. 1 anni</label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-2">
                                <label>Tipologia del rischio: Rumore</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="rumore_evidenza"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="rumore_data_redazione">Data redazione</label>
                                <input type="date" class="form-control" v-model="rumore_data_redazione">
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Predisporre</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="rumore_data_redazione"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                <label>Note: Agg. a seguito di modifiche o almeno ogni 4 anni.</label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-2">
                                <label>Tipologia del rischio: Vibrazioni</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="vibrazione_evidenza"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="vibrazione_data_redazione">Data redazione</label>
                                <input type="date" class="form-control" v-model="vibrazione_data_redazione">
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Predisporre</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="vibrazione_predisporre"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                <label>Note: Agg. a seguito di modifiche o almeno ogni 4 anni.</label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-2">
                                <label>Tipologia del rischio: Videoterminale</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="videoterminale_evidenza"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="videoterminale_data_redazione">Data redazione</label>
                                <input type="date" class="form-control" v-model="videoterminale_data_redazione">
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Predisporre</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="videoterminale_predisporre"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                <label>Note: Agg. a seguito di modifiche delle postazioni</label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-2">
                                <label>Tipologia del rischio: Amianto</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="amianto_evidenza"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="amianto_data_redazione">Data redazione</label>
                                <input type="date" class="form-control" v-model="amianto_data_redazione">
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Predisporre</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="amianto_predisporre"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                <label>Note: Agg. a seguito di modifiche o prima di demolizioni</label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-2">
                                <label>Tipologia del rischio: Biologico (es. laboratorio di analisi, rifiuti, az. Sanitarie)</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="biologico_evidenza"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="biologico_data_redazione">Data redazione</label>
                                <input type="date" class="form-control" v-model="biologico_data_redazione">
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Predisporre</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="biologico_predisporre"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                <label>Note: Agg. a seguito di modifiche o almeno ogni 4 anni.</label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-2">
                                <label>Tipologia del rischio: Cancerogeno/mutageni  (es. polveri di legno, benzina)</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="cancerogeno_evidenza"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="cancerogeno_data_redazione">Data redazione</label>
                                <input type="date" class="form-control" v-model="cancerogeno_data_redazione">
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Predisporre</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="cancerogeno_predisporre"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                <label>Note: Agg. a seguito di modifiche o almeno ogni 3 anni.</label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-2">
                                <label>Tipologia del rischio: Campi elettromagnetici</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="campi_el_evidenza"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="campi_el_data_redazione">Data redazione</label>
                                <input type="date" class="form-control" v-model="campi_el_data_redazione">
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Predisporre</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="campi_el_predisporre"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                <label>Note: Agg. a seguito di modifiche o almeno ogni 4 anni.</label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-2">
                                <label>Tipologia del rischio: Movimentazione carichi sollevamento e trasporto, spinta e traino, movimenti ripetuti</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="movimentazione_evidenza"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="movimentazione_data_redazione">Data redazione</label>
                                <input type="date" class="form-control" v-model="movimentazione_data_redazione">
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Predisporre</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="movimentazione_predisporre"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                <label>Note: Agg. a seguito di modifiche</label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-2">
                                <label>Tipologia del rischio: Radiazioni ottiche</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="radiazioni_evidenza"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="radiazioni_data_redazione">Data redazione</label>
                                <input type="date" class="form-control" v-model="radiazioni_data_redazione">
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Predisporre</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="radiazioni_predisporre"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                <label>Note: Agg. a seguito di modifiche</label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-2">
                                <label>Tipologia del rischio: Lavoratrici in gravidanza, differenza di genere, differenza di provenienza</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="lavoratrici_evidenza"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="lavoratrici_data_redazione">Data redazione</label>
                                <input type="date" class="form-control" v-model="lavoratrici_data_redazione">
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Predisporre</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="lavoratrici_predisporre"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                <label></label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-2">
                                <label>Tipologia del rischio: Legionella</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="legionella_evidenza"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="legionella_data_redazione">Data redazione</label>
                                <input type="date" class="form-control" v-model="legionella_data_redazione">
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Predisporre</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="legionella_predisporre"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                <label></label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-2">
                                <label>Tipologia del rischio: Microclima</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="microclima_evidenza"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="microclima_data_redazione">Data redazione</label>
                                <input type="date" class="form-control" v-model="microclima_data_redazione">
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Predisporre</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="microclima_predisporre"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                <label></label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-2">
                                <label>Tipologia del rischio: Radiazioni solari</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="radiazioni_solari_evidenza"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="radiazioni_solari_data_redazione">Data redazione</label>
                                <input type="date" class="form-control" v-model="radiazioni_solari_data_redazione">
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Predisporre</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="radiazioni_solari_predisporre"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                <label></label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-center">
                            <div class="form-group col-md-2">
                                <label>Tipologia del rischio: COVID-19</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="covid_evidenza"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label for="covid_data_redazione">Data redazione</label>
                                <input type="date" class="form-control" v-model="covid_data_redazione">
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Predisporre</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="covid_predisporre"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                <label></label>
                            </div>
                        </div>
                        <button v-on:click="tabIndex = 3" class="btn">Avanti</button>
                    </b-card-text>
                </b-tab>
                <b-tab title="Tab 4" :title-link-class="linkClass(3)">
                    <b-card-text>
                        <div class="form-row justify-content-center">
                            <div class="form-group col-md-4">
                                <label>Tipologia del rischio:<br> Caduta dall'alto</label>
                            </div>
                            <div class="form-group col-md-4">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Presente</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="caduta_presente"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-4">
                                <label>Note</label>
                                <textarea lass="form-control" v-model="caduta_note" rows="3" style="width:100%;border-radius:7px"></textarea>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-center">
                            <div class="form-group col-md-4">
                                <label>Tipologia del rischio:<br>Caduta oggetti dall'alto</label>
                            </div>
                            <div class="form-group col-md-4">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Presente</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="caduta_oggetti_presente"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-4">
                                <label>Note</label>
                                <textarea lass="form-control" v-model="caduta_oggetti_note" rows="3" style="width:100%;border-radius:7px"></textarea>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-center">
                            <div class="form-group col-md-4">
                                <label>Tipologia del rischio:<br>Scivolamento a livello</label>
                            </div>
                            <div class="form-group col-md-4">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Presente</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="scivolamento_presente"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-4">
                                <label>Note</label>
                                <textarea lass="form-control" v-model="scivolamento_note" rows="3" style="width:100%;border-radius:7px"></textarea>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-center">
                            <div class="form-group col-md-4">
                                <label>Tipologia del rischio:<br>Elettrocuzione</label>
                            </div>
                            <div class="form-group col-md-4">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Presente</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="elettrocuzione_presente"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-4">
                                <label>Note</label>
                                <textarea lass="form-control" v-model="elettrocuzione_note" rows="3" style="width:100%;border-radius:7px"></textarea>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-center">
                            <div class="form-group col-md-4">
                                <label>Tipologia del rischio:<br>Tagli e abrasioni</label>
                            </div>
                            <div class="form-group col-md-4">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Presente</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="tagli_abrasioni_presente"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-4">
                                <label>Note</label>
                                <textarea lass="form-control" v-model="tagli_abrasioni_note" rows="3" style="width:100%;border-radius:7px"></textarea>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-center">
                            <div class="form-group col-md-4">
                                <label>Tipologia del rischio:<br>Meccanico</label>
                            </div>
                            <div class="form-group col-md-4">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Presente</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="meccanico_presente"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-4">
                                <label>Note</label>
                                <textarea lass="form-control" v-model="meccanico_note" rows="3" style="width:100%;border-radius:7px"></textarea>
                            </div>
                        </div>
                        <button v-on:click="tabIndex = 4" class="btn">Avanti</button>
                    </b-card-text>
                </b-tab>
                <b-tab title="Tab 5" :title-link-class="linkClass(4)">
                    <b-card-text>
                        <h2>FORMAZIONE</h2>
                        <div class="form-row justify-content-center">
                            <div class="form-group col-md-3">
                                <label>Principali corsi:<br>RSPP Datore di lavoro</label>
                            </div>
                            <div class="form-group col-md-2">
                                <label>5 anni</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="rspp_datore_evidenze"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label>Mese e anno</label>
                                <input type="month" class="form-control" v-model="rspp_datore_mese">
                            </div>
                            <div class="form-group col-md-3">
                                <label>Rischio basso: 16h<br>
                                    Rischio medio: 32h<br>
                                    Rischio alto: 48h
                                </label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-center">
                            <div class="form-group col-md-3">
                                <label>Principali corsi:<br>RSPP esterno</label>
                            </div>
                            <div class="form-group col-md-2">
                                <label>Verifica attestato</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="rspp_esterno_evidenze_formazione"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label></label>
                            </div>
                            <div class="form-group col-md-3">
                                <label> </label>
                            </div>
                        </div>

                        <hr>
                        <div class="form-row justify-content-center">
                            <div class="form-group col-md-3">
                                <label>Principali corsi:<br>Addetti antincendio</label>
                            </div>
                            <div class="form-group col-md-2">
                                <label>5 anni</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="addetti_antincendio_evidenze_formazione"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label>Mese e anno</label>
                                <input type="month" class="form-control" v-model="addetti_antincendio_mese">
                            </div>
                            <div class="form-group col-md-3">
                                <label>Rischio basso: 4h<br>
                                        Rischio medio: 8h<br>
                                        Rischio alto: 12h
                                </label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-center">
                            <div class="form-group col-md-3">
                                <label>Principali corsi:<br>Preposti</label>
                            </div>
                            <div class="form-group col-md-2">
                                <label>3 anni*</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="preposti_evidenze_formazione"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label>Mese e anno</label>
                                <input type="month" class="form-control" v-model="preposti_mese">
                            </div>
                            <div class="form-group col-md-3">
                                <label>Nomina obbligatoria</label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-center">
                            <div class="form-group col-md-3">
                                <label>Principali corsi:<br>Dirigenti</label>
                            </div>
                            <div class="form-group col-md-2">
                                <label>5 anni</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="dirigenti_evidenze_formazione"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label>Mese e anno</label>
                                <input type="month" class="form-control" v-model="dirigenti_mese">
                            </div>
                            <div class="form-group col-md-3">
                                <label></label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-center">
                            <div class="form-group col-md-3">
                                <label>Principali corsi:<br>Carrelli elevatori</label>
                            </div>
                            <div class="form-group col-md-2">
                                <label>5 anni</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="carrelli_elevatori_evidenze_formazione"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label>Mese e anno</label>
                                <input type="month" class="form-control" v-model="carrelli_elevatori_mese">
                            </div>
                            <div class="form-group col-md-3">
                                <label> modulo teoria: 8h<br>
                                        modulo pratica: 4h
                                </label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-center">
                            <div class="form-group col-md-3">
                                <label>Principali corsi:<br>Gru (vari tipi)</label>
                            </div>
                            <div class="form-group col-md-2">
                                <label>5 anni</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="gru_evidenze_formazione"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label>Mese e anno</label>
                                <input type="month" class="form-control" v-model="gru_mese">
                            </div>
                            <div class="form-group col-md-3">
                                <label></label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-center">
                            <div class="form-group col-md-3">
                                <label>Principali corsi:<br>Formazione lavoratori</label>
                            </div>
                            
                            <div class="form-group col-md-2">
                                <label>Sempre valido</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="formazione_lavoratori_evidenze_formazione"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label>Mese e anno<br>Vedi allegato</label>
                                <input type="month" class="form-control" v-model="formazione_lavoratori_mese">
                            </div>
                            <div class="form-group col-md-3">
                                <label>Per tutti i rischi: 4h</label>
                            </div>
                        </div>
                        <div class="form-row justify-content-center">
                            <div class="form-group col-md-3">
                            </div>
                            
                            <div class="form-group col-md-3">
                                <label for="formazione_lavoratori_formati">Lavoratori formati n.</label>
                                <input type="number" class="form-control" v-model="formazione_lavoratori_formati">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="formazione_lavoratori_formare">Lavoratori da formare n.</label>
                                <input type="number" class="form-control" v-model="formazione_lavoratori_formare">
                            </div>
                            <div class="form-group col-md-3"></div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-center">
                            <div class="form-group col-md-3">
                                <label>Principali corsi:<br>Rischi specifici</label>
                            </div>
                            
                            <div class="form-group col-md-2">
                                <label>5 anni</label>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Evidenza</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="rischi_evidenze_formazione"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label>Mese e anno<br>Vedi allegato</label>
                                <input type="month" class="form-control" v-model="rischio_lavoratori_mese">
                            </div>
                            <div class="form-group col-md-3">
                                <label>Rischio basso: 16h<br>
                                        Rischio medio: 32h<br>
                                        Rischio alto: 48h
                                </label>
                            </div>
                        </div>
                        <div class="form-row justify-content-center">
                            <div class="form-group col-md-3">
                            </div>
                            
                            <div class="form-group col-md-3">
                                <label for="rischio_lavoratori_formati">Lavoratori formati n.</label>
                                <input type="number" class="form-control" v-model="rischio_lavoratori_formati">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="rischio_lavoratori_formare">Lavoratori da formare n.</label>
                                <input type="number" class="form-control" v-model="rischio_lavoratori_formare">
                            </div>
                            <div class="form-group col-md-3"></div>
                        </div>
                        <button v-on:click="tabIndex = 5" class="btn">Avanti</button>
                    </b-card-text>
                </b-tab>
                <b-tab title="Tab 6" :title-link-class="linkClass(5)">
                    <b-card-text>
                        <h2>AMBIENTI DI LAVORO - principali adempimenti</h2>
                        <h4>Segnaletica di sicurezza</h4>
                        <div class="form-row justify-content-start">
                            <div class="form-group col-md-3">
                                Estintori:
                            </div>
                            <div class="form-group col-md-3">
                                <label for="estintori_presente"><input type="radio" value="estintori_presente" v-model="estintori" style="margin-right:5px">Presente</label><br>
                            </div>
                            <div class="form-group col-md-3">
                               <label for="estintori_assente"><input type="radio" value="estintori_assente" v-model="estintori" style="margin-right:5px">Assente</label><br>
                            </div>
                            <div class="form-group col-md-3">
                                <label for="estintori_integrare"><input type="radio" value="estintori_integrare" v-model="estintori" style="margin-right:5px">Integrare</label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-start">
                            <div class="form-group col-md-3">
                                 Vie di fuga:
                            </div>
                            <div class="form-group col-md-3">
                                <label for="vie_fuga_presente"><input type="radio" value="vie_fuga_presente" v-model="vie_fuga" style="margin-right:5px">Presente</label><br>
                            </div>
                            <div class="form-group col-md-3">
                               <label for="vie_fugai_assente"><input type="radio" value="vie_fuga_assente" v-model="vie_fuga" style="margin-right:5px">Assente</label><br>
                            </div>
                            <div class="form-group col-md-3">
                                <label for="vie_fuga_integrare"><input type="radio" value="vie_fuga_integrare" v-model="vie_fuga" style="margin-right:5px">Integrare</label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-start">
                            <div class="form-group col-md-3">
                                Su macchine ed attrezzatura:
                            </div>
                            <div class="form-group col-md-3">
                                <label for="macchine_attrezzatura_presente"><input type="radio" value="macchine_attrezzatura_presente" v-model="macchine_attrezzatura" style="margin-right:5px">Presente</label><br>
                            </div>
                            <div class="form-group col-md-3">
                               <label for="macchine_attrezzatura_assente"><input type="radio" value="macchine_attrezzatura_assente" v-model="macchine_attrezzatura" style="margin-right:5px">Assente</label><br>
                            </div>
                            <div class="form-group col-md-3">
                                <label for="macchine_attrezzatura_integrare"><input type="radio" value="macchine_attrezzatura_integrare" v-model="macchine_attrezzatura" style="margin-right:5px">Integrare</label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-start">
                            <div class="form-group col-md-3">
                                Destinazione d'uso dei locali:
                            </div>
                            <div class="form-group col-md-3">
                                <label for="destinazione_uso_locale_presente"><input type="radio" value="destinazione_uso_locale_presente" v-model="destinazione_uso_locale" style="margin-right:5px">Presente</label><br>
                            </div>
                            <div class="form-group col-md-3">
                               <label for="destinazione_uso_locale_assente"><input type="radio" value="destinazione_uso_locale_assente" v-model="destinazione_uso_locale" style="margin-right:5px">Assente</label><br>
                            </div>
                            <div class="form-group col-md-3">
                                <label for="destinazione_uso_locale_integrare"><input type="radio" value="destinazione_uso_locale_integrare" v-model="destinazione_uso_locale" style="margin-right:5px">Integrare</label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-start">
                            <div class="form-group col-md-3">
                                Sui contenitori dei prodotti chimici:
                            </div>
                            <div class="form-group col-md-3">
                                <label for="contenitori_prodotti_chimici_presente"><input type="radio" value="contenitori_prodotti_chimici_presente" v-model="contenitori_prodotti_chimici" style="margin-right:5px">Presente</label><br>
                            </div>
                            <div class="form-group col-md-3">
                               <label for="contenitori_prodotti_chimici_assente"><input type="radio" value="contenitori_prodotti_chimici_assente" v-model="contenitori_prodotti_chimici" style="margin-right:5px">Assente</label><br>
                            </div>
                            <div class="form-group col-md-3">
                                <label for="contenitori_prodotti_chimici_integrare"><input type="radio" value="contenitori_prodotti_chimici_integrare" v-model="contenitori_prodotti_chimici" style="margin-right:5px">Integrare</label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-start">
                            <div class="form-group col-md-3">
                                Servizi igenici:
                            </div>
                            <div class="form-group col-md-3">
                                Divisi per sesso sopra le 10 unità
                                <div class="form-row justify-content-md-center">
                                    <label class="switch"> <input type="checkbox" class="form-control" v-model="servizi_igenici_divisi"><span class="slider round"></span></label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                Dotati di antibagno
                                        <div class="form-row justify-content-md-center">
                                            <label class="switch"> <input type="checkbox" class="form-control" v-model="servizi_igenici_antibagno"><span class="slider round"></span></label>
                                        </div>
                            </div>
                            <div class="form-group col-md-3"></div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-start">
                            <div class="form-group col-md-3">
                                Aerazione naturale (finestre, lucernari, etc):
                            </div>
                            <div class="form-group col-md-3">
                                <label for="aerazione_naturale_presente"><input type="radio" value="aerazione_naturale_presente" v-model="aerazione_naturale" style="margin-right:5px">Presente</label><br>
                            </div>
                            <div class="form-group col-md-3">
                               <label for="aerazione_naturale_assente"><input type="radio" value="aerazione_naturale_assente" v-model="aerazione_naturale" style="margin-right:5px">Assente</label><br>
                            </div>
                            <div class="form-group col-md-3"></div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-start">
                            <div class="form-group col-md-3">
                                Illuminazione naturale:
                            </div>
                            <div class="form-group col-md-3">
                                <label for="illuminazione_naturale_presente"><input type="radio" value="illuminazione_naturale_presente" v-model="illuminazione_naturale" style="margin-right:5px">Presente</label><br>
                                <label for="illuminazione_naturale_insufficiente"><input type="radio" value="illuminazione_naturale_insufficiente" v-model="illuminazione_naturale" style="margin-right:5px">Insufficiente</label><br>
                                <label for="illuminazione_naturale_assente"><input type="radio" value="illuminazione_naturale_assente" v-model="illuminazione_naturale" style="margin-right:5px">Assente</label><br>
                            </div>
                            <div class="form-group col-md-3">
                                <label for="schermata_tendaggi"><input type="checkbox" v-model="schermata_tendaggi" style="margin-right:5px">schermata con tendaggi</label><br>
                                <label for="schermata_veneziane"><input type="checkbox" v-model="schermata_veneziane" style="margin-right:5px">schermata con veneziane</label>
                            </div>
                            <div class="form-group col-md-3">
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-start">
                            <div class="form-group col-md-3">
                                Illuminazione artificiale:
                            </div>
                            <div class="form-group col-md-3">
                                <label for="illuminazione_artificiale_presente"><input type="radio" value="illuminazione_artificiale_presente" v-model="illuminazione_artificiale" style="margin-right:5px">Presente</label><br>
                               <label for="illuminazione_artificiale_assente"><input type="radio" value="illuminazione_artificiale_assente" v-model="illuminazione_artificiale" style="margin-right:5px">Assente</label><br>
                            </div>
                            <div class="form-group col-md-3">
                                <label for="antiriflesso">In ufficio: <input type="checkbox" v-model="antiriflesso" style="margin-right:5px">antiriflesso</label>
                            </div>
                            <div class="form-group col-md-3">
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-start">
                            <div class="form-group col-md-3">
                                Scale:
                            </div>
                            <div class="form-group col-md-3">
                                Parapetto h > 1m:
                                <div class="form-row justify-content-md-center">
                                    <label class="switch"> <input type="checkbox" class="form-control" v-model="scale_parapetto"><span class="slider round"></span></label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                Gradini antiscivolo:
                                <div class="form-row justify-content-md-center">
                                    <label class="switch"> <input type="checkbox" class="form-control" v-model="gradini_antiscivolo"><span class="slider round"></span></label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                Corrimano:<br>
                                <label for="corrimano_presente"><input type="radio" value="corrimano_presente" v-model="corrimano" style="margin-right:5px;">Presente</label>
                                <label for="corrimano_assente"><input type="radio" value="corrimano_assente" v-model="corrimano" style="margin-left:10px;margin-right:5px">Assente</label>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-start">
                            <div class="form-group col-md-3">
                                Scale portatili:
                            </div>
                            <div class="form-group col-md-3">
                                Praticabili:<br>
                                <label for="parapetto"><input type="checkbox" v-model="parapetto" style="margin-right:5px">Parapetto</label><br>
                                <label for="indicazione_portata_scale"><input type="checkbox" v-model="indicazione_portata_scale" style="margin-right:5px">indicazione portata</label><br>
                            </div>
                            <div class="form-group col-md-3">
                                <label for="scale_conformi_si"><input type="radio" value="scale_conformi_si" v-model="scale_conformi" style="margin-right:5px;">Si</label>
                                <label for="scale_conformi_no"><input type="radio" value="scale_conformi_no" v-model="scale_conformi" style="margin-left:10px;margin-right:5px">No</label> 
                            </div>
                            <div class="form-group col-md-3"></div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-start">
                            <div class="form-group col-md-3">
                                Soppalchi:
                            </div>
                            <div class="form-group col-md-3">
                                <label for="soppalchi_conformi_si"><input type="radio" value="soppalchi_conformi_si" v-model="soppalchi_conformi" style="margin-right:5px;">Si</label>
                                <label for="soppalchi_conformi_no"><input type="radio" value="soppalchi_conformi_no" v-model="soppalchi_conformi" style="margin-left:10px;margin-right:5px">No</label> 
                            </div>
                            <div class="form-group col-md-4">
                                <label for="presenza_scale">Non praticabili: <input type="checkbox" v-model="presenza_scale" style="margin-right:5px;">Presenza di scale</label>
                            </div>
                            <div class="form-group col-md-2"></div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-start">
                            <div class="form-group col-md-3">
                                Scaffalature:
                            </div>
                            <div class="form-group col-md-3">
                                <label for="scaffalature"><input type="checkbox" v-model="scaffalature_fisse" style="margin-right:5px;">fissate a parete o pavimento</label>
                            </div>
                            <div class="form-group col-md-3">
                                <label for="indicazione_portata_soppalchi"><input type="checkbox" v-model="indicazione_portata_soppalchi" style="margin-right:5px;">indicazione portata</label>
                                <label for="presenza_paracolpi_base"><input type="checkbox" v-model="presenza_paracolpi_base" style="margin-right:5px;">presenza di paracolpi alla base</label>
                            </div>
                            <div class="form-group col-md-3"></div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-start">
                            <div class="form-group col-md-3">
                                Estintori:
                            </div>
                            <div class="form-group col-md-3">
                                <label for="numero_estintori">N.</label>
                                <input type="number" class="form-control" v-model="numero_estintori">
                            </div>
                            <div class="form-group col-md-3">
                                Controllo semestrale<br>
                                <label for="controllo_semestrale_si"><input type="radio" value="si" v-model="controllo_semestrale" style="margin-right:5px;">Si</label>
                                <label for="controllo_semestrale_no"><input type="radio" value="no" v-model="controllo_semestrale" style="margin-left:10px;margin-right:5px">No</label> 
                            </div>
                            <div class="form-group col-md-3"></div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-start">
                            <div class="form-group col-md-3">
                                Cassetta P.S. Agg.ta e segnalata
                            </div>
                            <div class="form-group col-md-3">
                                <label for="cassetta_si"><input type="radio" value="si" v-model="cassetta" style="margin-right:5px;">Si</label>
                                <label for="cassetta_no"><input type="radio" value="no" v-model="cassetta" style="margin-left:10px;margin-right:5px">No</label> 
                            </div>
                            <div class="form-group col-md-3">
                            </div>
                            <div class="form-group col-md-3"></div>
                        </div>
                        <button v-on:click="tabIndex = 6" class="btn">Avanti</button>
                    </b-card-text>
                </b-tab>
                <b-tab title="Tab 7" :title-link-class="linkClass(6)">
                    <b-card-text>
                        <h3>Prevenzione incendi</h3>
                        <div class="form-row justify-content-start">
                            <div class="form-group col-md-6">
                                Certificato di prevenzione incendi (CPI)(Centrale Termica sopra 100.000 Kcal, autorimessa con autoveicoli, carta o legna sopra i 50 q.li, serbatoi di gpl sopra i 0,5 mc, diesel tank, superficie coperta sopra i 1000 mq.)
                            </div>
                            <div class="form-group col-md-3">
                                <label for="certificato_prevenzione_si"><input type="radio" value="si" v-model="certificato_prevenzione" style="margin-right:5px;">Si</label>
                                <label for="certificato_prevenzione_no"><input type="radio" value="no" v-model="certificato_prevenzione" style="margin-left:10px;margin-right:5px">No</label><br>
                                <label for="anno_certificazione">Anno</label>
                                <input type="text" class="form-control" v-model="anno_certificazione"> 
                            </div>
                            <div class="form-group col-md-3">
                                Solo con attività soggette
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-start">
                            <div class="form-group col-md-6">
                                Piano di emergenza con allegato planimetria evacuazione
                            </div>
                            <div class="form-group col-md-3">
                                <label for="piano_emergenza_si"><input type="radio" value="si" v-model="piano_emergenza" style="margin-right:5px;">Si</label>
                                <label for="piano_emergenza_no"><input type="radio" value="no" v-model="piano_emergenza" style="margin-left:10px;margin-right:5px">No</label><br>
                                <label for="anno_piano_emergenza">Anno</label>
                                <input type="text" class="form-control" v-model="anno_piano_emergenza">
                            </div>
                            <div class="form-group col-md-3">
                                Solo con dipendenti>10
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-start">
                            <div class="form-group col-md-6">
                               Prova evacuazione annuale
                            </div>
                            <div class="form-group col-md-3">
                                <label for="prova_evacuazione_annuale_si"><input type="radio" value="si" v-model="prova_evacuazione_annuale" style="margin-right:5px;">Si</label>
                                <label for="prova_evacuazione_annuale_no"><input type="radio" value="no" v-model="prova_evacuazione_annuale" style="margin-left:10px;margin-right:5px">No</label><br> 
                                <label for="prova_evacuazione_annuale_anno">Anno</label>
                                <input type="text" class="form-control" v-model="anno_prova_evacuazione_annuale">
                            </div>
                            <div class="form-group col-md-3">
                                Solo con dipendenti>10
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-start">
                            <div class="form-group col-md-6">
                                Registro presidi di emergenza
                            </div>
                            <div class="form-group col-md-3">
                                <label for="registro_piani_emergenza_si"><input type="radio" value="si" v-model="registro_piani_emergenza" style="margin-right:5px;">Si</label>
                                <label for="registro_piani_emergenza_no"><input type="radio" value="no" v-model="registro_piani_emergenza" style="margin-left:10px;margin-right:5px">No</label><br>
                                <label for="registro_piani_emergenza_anno">Anno</label>
                                <input type="text" class="form-control" v-model="registro_piani_emergenza_anno">
                            </div>
                            <div class="form-group col-md-3">
                                Solo con CPI
                            </div>
                        </div>
                        <h3>Lista principali documenti presenti in azienda</h3>
                        <div class="form-row justify-content-start">
                            <div class="form-group col-md-1">
                                1.
                            </div>
                            <div class="form-group col-md-4">
                                Planimetria locali
                            </div>
                            <div class="form-group col-md-3">
                                <label>Data</label>
                                <input type="date" class="form-control" v-model="planimetria_locali_data">
                            </div>
                            <div class="form-group col-md-4">
                                <label>Note</label>
                                <textarea lass="form-control" v-model="planimetria_locali_note" rows="3" style="width:100%;border-radius:7px"></textarea>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-start">
                            <div class="form-group col-md-1">
                                2.
                            </div>
                            <div class="form-group col-md-4">
                                Dichiarazione conformità imp. elettrico (L. 37/08 ex 46/90)
                            </div>
                            <div class="form-group col-md-3">
                                <label>Data</label>
                                <input type="date" class="form-control" v-model="dichiarazione_conformita_elettrico_data">
                            </div>
                            <div class="form-group col-md-4">
                                <label>Note</label>
                                <textarea lass="form-control" v-model="dichiarazione_conformita_elettrico_note" rows="3" style="width:100%;border-radius:7px"></textarea>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-start">
                            <div class="form-group col-md-1">
                                3.
                            </div>
                            <div class="form-group col-md-4">
                                Dichiarazione conformità imp. termico (L. 37/08 ex 46/90)
                            </div>
                            <div class="form-group col-md-3">
                                <label>Data</label>
                                <input type="date" class="form-control" v-model="dichiarazione_conformita_termico_data">
                            </div>
                            <div class="form-group col-md-4">
                                <label>Note</label>
                                <textarea lass="form-control" v-model="dichiarazione_conformita_termico_note" rows="3" style="width:100%;border-radius:7px"></textarea>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-start">
                            <div class="form-group col-md-1">
                                4.
                            </div>
                            <div class="form-group col-md-4">
                                Verifica periodica impianto di messa a terra (ogni 2 se esiste CPI o 5 anni in assenza di CPI)
                            </div>
                            <div class="form-group col-md-3">
                                <label>Data</label>
                                <input type="date" class="form-control" v-model="verifica_periodica_impianto_data">
                            </div>
                            <div class="form-group col-md-4">
                                <label>Note</label>
                                <textarea lass="form-control" v-model="verifica_periodica_impianto_note" rows="3" style="width:100%;border-radius:7px"></textarea>
                            </div>
                        </div>
                        <hr>
                        <div class="form-row justify-content-start">
                            <div class="form-group col-md-1">
                                5.
                            </div>
                            <div class="form-group col-md-4">
                                Agibilità dei locali
                            </div>
                            <div class="form-group col-md-3">
                                <label>Data</label>
                                <input type="date" class="form-control" v-model="agibilita_locali_data">
                            </div>
                            <div class="form-group col-md-4">
                                <label>Note</label>
                                <textarea lass="form-control" v-model="agibilita_locali_note" rows="3" style="width:100%;border-radius:7px"></textarea>
                            </div>
                        </div>
                        <button v-on:click="tabIndex = 7" class="btn">Avanti</button>
                    </b-card-text>
                </b-tab>
                <b-tab title="Tab 8" :title-link-class="linkClass(7)">
                    <b-card-text>
                        <div class="form-row justify-content-start">
                            <label class="form-group justify-content-md-center col-md">LISTA ATTREZZATURE</label>
                        </div>
                        <div class="form-row justify-content-start">
                            <textarea class="form-group justify-content-md-center col-md" rows="10" v-model="lista_attrezzature"></textarea>
                        </div>
                        <div class="form-row justify-content-start">
                            <label class="form-group justify-content-md-center col-md">LISTA SOSTANZE CHIMICHE – SCHEDE DI SICUREZZA – QUANTITA’ UTILIZZATE</label>
                        </div>
                        <div class="form-row justify-content-start">
                            <textarea class="form-group justify-content-md-center col-md" id="w3review" name="w3review" rows="10" v-model="lista_sostanze_chimiche"></textarea>
                        </div>
                        <div class="form-row justify-content-start">
                            <label class="form-group justify-content-md-center col-md">MANSIONI DIPENDENTI</label>
                        </div>
                        <div class="form-row justify-content-start">
                            <textarea class="form-group justify-content-md-center col-md" id="w3review" name="w3review" rows="10" v-model="lista_mansioni_dipendenti"></textarea>
                        </div>
                        <button v-on:click="main()" class="btn">Salva</button>
                    </b-card-text>
                </b-tab>
            </b-tabs>
        </b-card>

        <!-- <button class="btn float-right" type="button" v-on:click="salvaValoriIdentificazione()" style="margin-top: 10px;background:#00467f">Salva</button> -->
        <!--<button class="btn float-right" type="button" v-on:click="salvaValoriDati()" style="margin-top: 10px;background:#00467f">Salva</button>-->
        <!-- <router-link :to="'valutazione-a?idCliente='+idCliente"><button class="btn float-right" type="button" style="margin-top: 10px;margin-right:20px;background:#00467f">Avanti</button></router-link>
        <router-link to="/clienti" class="btn float-right" style="margin-top: 10px;margin-right:10px;background:#00467f">Indietro</router-link> -->
        
    </card>
  </div>
</template>
<script>
import Card from "@/components/Cards/Card.vue";
import Services from '@/services/Services';
import ChecklistServices from '@/services/ChecklistServices';

export default {
    components: {
        Card
    },

    data() {
        return {
            // TAB 1
            data: null,
            ditta: null,
            n_sedi: null,
            sede_operativa: null,
            sede_legale: null,
            n_soci: null,
            n_soci_lavoratori: null,
            n_dipendenti: null,
            n_collaboratori: null,
            subapp: null,
            interferenze: null,
            descrizione_attivita: null,
            n_ore_settimanali: null,
            orario_notturno: false,
            orario_dalle: null,
            orario_alle: null,
            mansioni_dipendenti: null,
            note: null,

            // TAB 2
            datore_lavoro: null,
            delegato_sicurezza: false,
            data_delegato_sicurezza: null,
            rspp_sig: null,
            rspp_dl: false,
            medico_competente_dr: null,
            medico_non_nominato: null,
            medico_da_nominare: null,
            medico_in_fase_nomina: null,

            rls_sig: null,
            rls_non_nominato: null,
            rls_da_nominare: null,
            rls_in_fase_nomina: null,

            soccorso_sig1: null,
            soccorso_nomina_del1: null,
            soccorso_sig2: null,
            soccorso_nomina_del2: null,
            antincendio_sig1: null,
            antincendio_nomina_del1: null,
            antincendio_sig2: null,
            antincendio_nomina_del2: null,
            preposto_sig: null,
            preposto_nomina_del: null,
            
            // TAB 3
            dvr_evidenza: false,
            dvr_data_redazione: null,
            dvr_predisporre: false,

            pos_evidenza: false,
            pos_data_redazione: null,
            pos_predisporre: false,

            duvri_evidenza: false,
            duvri_data_redazione: null,
            duvri_predisporre: false,

            chimico_evidenza: false,
            chimico_data_redazione: null,
            chimico_predisporre: false,

            stress_evidenza: false,
            stress_data_redazione: null,
            stress_predisporre: false,

            incendio_evidenza: false,
            incendio_data_redazione: null,
            incendio_predisporre: false,

            atex_evidenza: false,
            atex_data_redazione: null,
            atex_predisporre: false,

            rumore_evidenza: false,
            rumore_data_redazione: null,
            rumore_predisporre: false,

            vibrazione_evidenza: false,
            vibrazione_data_redazione: null,
            vibrazione_predisporre: false,

            videoterminale_evidenza: false,
            videoterminale_data_redazione: null,
            videoterminale_predisporre: false,

            amianto_evidenza: false,
            amianto_data_redazione: null,
            amianto_predisporre: false,

            biologico_evidenza: false,
            biologico_data_redazione: null,
            biologico_predisporre: false,
            cancerogeno_evidenza: false,
            cancerogeno_data_redazione: null,
            cancerogeno_predisporre: false,

            campi_el_evidenza: false,
            campi_el_data_redazione: null,
            campi_el_predisporre: false,
            movimentazione_evidenza: false,
            movimentazione_data_redazione: null,
            movimentazione_predisporre: false,
            radiazioni_evidenza: false,
            radiazioni_data_redazione: null,
            radiazioni_predisporre: false,

            lavoratrici_evidenza: false,
            lavoratrici_data_redazione: null,
            lavoratrici_predisporre: false,

            legionella_evidenza: false,
            legionella_data_redazione: null,
            legionella_predisporre: false,

            microclima_evidenza: false,
            microclima_data_redazione: null,
            microclima_predisporre: false,
            radiazioni_solari_evidenza: false,
            radiazioni_solari_data_redazione: null,
            radiazioni_solari_predisporre: false,

            covid_evidenza: false,
            covid_data_redazione: null,
            covid_predisporre: false,

            // TAB 4
            caduta_presente: false,
            caduta_note: null,
            caduta_oggetti_presente: false,
            caduta_oggetti_note: null,
            scivolamento_presente: false,
            scivolamento_note: null,
            elettrocuzione_presente: false,
            elettrocuzione_note: null,
            tagli_abrasioni_presente: false,
            tagli_abrasioni_note: null,
            meccanico_presente: false,
            meccanico_note: null,

            // TAB 5
            rspp_datore_evidenze: null, 
            rspp_datore_evidenze_formazione: false, //
            rspp_datore_mese: null,
            rspp_esterno_evidenze_formazione: false,
            addetti_antincendio_evidenze_formazione: false,
            addetti_antincendio_mese: null,
            addetti_soccorso_evidenze_formazione: false, //
            addetti_soccorso_mese: null,
            preposti_evidenze_formazione: false,
            preposti_mese: null,
            dirigenti_evidenze_formazione: false,
            dirigenti_mese: false,
            carrelli_elevatori_evidenze_formazione: false,
            carrelli_elevatori_mese: null,
            gru_evidenze_formazione: false,
            gru_mese: null,
            formazione_lavoratori_evidenze_formazione: false,
            formazione_lavoratori_formati: null,
            formazione_lavoratori_formare: null,
            formazione_lavoratori_mese: null,
            rischi_evidenze_formazione: false,
            rischio_lavoratori_formati: null,
            rischio_lavoratori_formare: null,
            rischio_lavoratori_mese: null,

            // TAB 6
            estintori: 'estintori_assente',
            vie_fuga: 'vie_fuga_assente',
            macchine_attrezzatura: 'macchine_attrezzatura_assente',
            destinazione_uso_locale: 'destinazione_uso_locale_assente',
            contenitori_prodotti_chimici: 'contenitori_prodotti_chimici_assente',
            servizi_igenici_divisi: false,
            servizi_igenici_antibagno: false,
            aerazione_naturale: 'aerazione_naturale_assente',
            illuminazione_naturale: 'illuminazione_naturale_assente',
            schermata_tendaggi: null,
            schermata_veneziane: null,
            illuminazione_artificiale: 'illuminazione_artificiale_assente',
            antiriflesso: null,
            scale_parapetto: null,
            gradini_antiscivolo: null,
            corrimano: 'corrimano_assente',
            parapetto: null,
            indicazione_portata_scale: null,
            scale_conformi: 'scale_conformi_no',
            soppalchi_conformi: 'soppalchi_conformi_no',
            presenza_scale: null,
            
            scaffalature_fisse: null,
            indicazione_portata_soppalchi: null,
            presenza_paracolpi_base: null,
            numero_estintori: null,
            controllo_semestrale: 'no',
            cassetta: 'no',

            // TAB /7
            certificato_prevenzione: 'no',
            anno_certificazione: null,
            piano_emergenza: 'no',
            anno_piano_emergenza: null,
            prova_evacuazione_annuale: 'no',
            anno_prova_evacuazione_annuale: null,
            registro_piani_emergenza: 'no',
            registro_piani_emergenza_anno: null,
            planimetria_locali_data: null,
            planimetria_locali_note: null,
            dichiarazione_conformita_elettrico_data: null,
            dichiarazione_conformita_elettrico_note: null,
            dichiarazione_conformita_termico_data: null,
            dichiarazione_conformita_termico_note: null,
            verifica_periodica_impianto_data: null,
            verifica_periodica_impianto_note: null,
            agibilita_locali_data: null,
            agibilita_locali_note: null,

            // TAB /8
            lista_attrezzature: null,
            lista_sostanze_chimiche: null,
            lista_mansioni_dipendenti: null,

            TAB1: null,
            TAB2: null,
            TAB3: null,
            TAB4: null,
            TAB5: null,
            TAB6: null,
            TAB7: null,
            TAB8: null,

            tabIndex: 0,
            id: this.$route.query.id,
            TOKEN : this.$route.query.token
        }
    },
    computed: {},

    methods: {
        linkClass(idx) {
            if (this.tabIndex === idx) {
            return ['bg-confcommercio']
            } else {
            return ['text-confcommercio']
            }
        },

        checkData: function() {
            if (
                this.data == null ||  this.ditta == null || this.n_sedi ==  null || this.sede_operativa == null || this.sede_legale == null || this.n_soci == null 
                || this.n_soci_lavoratori == null || this.n_dipendenti == null || this.n_collaboratori == null || this.subapp == null || this.interferenze == null 
                || this.descrizione_attivita == null || this.n_ore_settimanali == null || this.mansioni_dipendenti == null || this.note == null
            ) {
                alert("Compilare tutti i dati!");
                return false;
            }else if(this.orario_notturno == true && (this.orario_dalle == null || this.orario_alle == null)) {
                alert("Compilare tutti i dati!");
                return false;
            }else
                return true;
        },

        salvaTab1: function() {
            this.TAB1 = {
                DATA: this.data, DITTA: this.ditta, N_SEDI: this.n_sedi, SEDE_OPERATIVA: this.sede_operativa,  SEDE_LEGALE: this.sede_legale,
                N_SOCI: this.n_soci, N_SOCI_LAVORATORI: this.n_soci_lavoratori, N_DIPENDENTI: this.n_dipendenti, N_COLLABORATORI: this.n_collaboratori,
                SUBAPP:this.subapp, INTERFERENZE: this.interferenze, DESCRIZIONE_ATTIVITA: this.descrizione_attivita, N_ORE_SETTIMANALI: this.n_ore_settimanali,
                ORARIO_NOTTURNO: this.orario_notturno, ORARIO_DALLE: this.orario_dalle, ORARIO_ALLE: this.orario_alle, MANSIONI_DIPENDENTI: this.mansioni_dipendenti,
                NOTE: this.note
            };
            console.log(`tab 1`);
            console.log(this.TAB1);
        },

        salvaTab2: function() {
            this.TAB2 = {
                DATORE_LAVORO: this.datore_lavoro, DELEGATO_SICUREZZA: this.delegato_sicurezza, DATA_DELEGATO_SICUREZZA: this.data_delegato_sicurezza, RSPP_SIG: this.rspp_sig,
                RSPP_DL: this.rspp_dl, MEDICO_COMPETENTE_DR: this.medico_competente_dr, MEDICO_NON_NOMINATO: this.medico_non_nominato, MEDICO_DA_NOMINARE: this.medico_da_nominare, MEDICO_IN_FASE_NOMINA: this.medico_in_fase_nomina, RLS_SIG: this.rls_sig, RLS_NON_NOMINATO: this.rls_non_nominato, 
                RLS_DA_NOMINARE: this.rls_da_nominare, RLS_IN_FASE_NOMINA: this.rls_in_fase_nomina, SOCCORSO_SIG1: this.soccorso_sig1, SOCCORSO_NOMINA_DEL1: this.soccorso_nomina_del1, 
                SOCCORSO_SIG2: this.soccorso_sig2, SOCCORSO_NOMINA_DEL2: this.soccorso_nomina_del2, ANTINCENDIO_SIG1: this.antincendio_sig1, ANTINCENDIO_NOMINA_DEL1: this.antincendio_nomina_del1, 
                ANTINCENDIO_SIG2: this.antincendio_sig2, ANTINCENDIO_NOMINA_DEL2: this.antincendio_nomina_del2, PREPOSTO_SIG: this.preposto_sig, PREPOSTO_NOMINA_DEL: this.preposto_nomina_del
            };
            console.log(`tab 2`);
            console.log(this.TAB2);
        },

        salvaTab3: function() {
            this.TAB3 = {
                DVR_EVIDENZA: this.dvr_evidenza, DVR_DATA_REDAZIONE: this.dvr_data_redazione, DVR_PREDISPORRE: this.dvr_predisporre, POS_EVIDENZA: this.pos_evidenza, POS_DATA_REDAZIONE: this.pos_data_redazione,
                POS_PREDISPORRE: this.pos_predisporre, DUVRI_EVIDENZA: this.duvri_evidenza, DUVRI_DATA_REDAZIONE: this.duvri_data_redazione, DUVRI_PREDISPORRE: this.duvri_predisporre,
                CHIMICO_EVIDENZA: this.chimico_evidenza, CHIMICO_DATA_REDAZIONE: this.chimico_data_redazione, CHIMICO_PREDISPORRE: this.chimico_predisporre, STRESS_EVIDENZA: this.stress_evidenza,
                STRESS_DATA_REDAZIONE: this.stress_data_redazione, STRESS_PREDISPORRE: this.stress_predisporre, INCENDIO_EVIDENZA: this.incendio_evidenza, INCENDIO_DATA_REDAZIONE: this.incendio_data_redazione,
                INCENDIO_PREDISPORRE: this.incendio_predisporre, ATEX_EVIDENZA: this.atex_evidenza, ATEX_DATA_REDAZIONE: this.atex_data_redazione, ATEX_PREDISPORRE: this.atex_predisporre,
                RUMORE_EVIDENZA: this.rumore_evidenza, RUMORE_DATA_REDAZIONE: this.rumore_data_redazione, RUMORE_PREDISPORRE: this.rumore_predisporre, VIBRAZIONE_EVIDENZA: this.vibrazione_evidenza,
                VIBRAZIONE_DATA_REDAZIONE: this.vibrazione_data_redazione, VIBRAZIONE_PREDISPORRE: this.vibrazione_predisporre, VIDEOTERMINALE_EVIDENZA: this.videoterminale_evidenza, VIDEOTERMINALE_DATA_REDAZIONE: this.videoterminale_data_redazione,
                VIDEOTERMINALE_PREDISPORRE: this.videoterminale_predisporre, AMIANTO_EVIDENZA: this.amianto_evidenza, AMIANTO_DATA_REDAZIONE: this.amianto_data_redazione, AMIANTO_PREDISPORRE: this.amianto_predisporre,
                BIOLOGICO_EVIDENZA: this.biologico_evidenza, BIOLOGICO_DATA_REDAZIONE: this.biologico_data_redazione, BIOLOGICO_PREDISPORRE: this.biologico_predisporre, 
                CANCEROGENO_EVIDENZA: this.cancerogeno_evidenza, CANCEROGENO_DATA_REDAZIONE: this.cancerogeno_data_redazione, CANCEROGENO_PREDISPORRE: this.cancerogeno_predisporre,
                CAMPI_EL_EVIDENZA: this.campi_el_evidenza,  CAMPI_EL_DATA_REDAZIONE: this.campi_el_data_redazione,  CAMPI_EL_PREDISPORRE: this.campi_el_predisporre, 
                MOVIMENTAZIONE_EVIDENZA: this.movimentazione_evidenza, MOVIMENTAZIONE_DATA_REDAZIONE: this.movimentazione_data_redazione, MOVIMENTAZIONE_PREDISPORRE: this.movimentazione_predisporre,
                RADIAZIONI_EVIDENZA: this.radiazioni_evidenza, RADIAZIONI_DATA_REDAZIONE: this.radiazioni_data_redazione, RADIAZIONI_PREDISPORRE: this.radiazioni_predisporre,
                LAVORATRICI_EVIDENZA: this.lavoratrici_evidenza, LAVORATRICI_DATA_REDAZIONE: this.lavoratrici_data_redazione, LAVORATRICI_PREDISPORRE: this.lavoratrici_predisporre,
                LEGIONELLA_EVIDENZA: this.legionella_evidenza, LEGIONELLA_DATA_REDAZIONE: this.legionella_data_redazione, LEGIONELLA_PREDISPORRE: this.legionella_predisporre,
                MICROCLIMA_EVIDENZA: this.microclima_evidenza, MICROCLIMA_DATA_REDAZIONE: this.microclima_data_redazione, MICROCLIMA_PREDISPORRE: this.microclima_predisporre,
                RADIAZIONI_SOLARI_EVIDENZA: this.radiazioni_solari_evidenza, RADIAZIONI_SOLARI_DATA_REDAZIONE: this.radiazioni_solari_data_redazione,RADIAZIONI_SOLARI_PREDISPORRE: this.radiazioni_solari_predisporre,
                COVID_EVIDENZA: this.covid_evidenza, COVID_DATA_REDAZIONE: this.covid_data_redazione, COVID_PREDISPORRE: this.covid_predisporre
            };
            console.log(`tab 3`);
            console.log(this.TAB3);
        },

        salvaTab4: function() {
            this.TAB4 = {
                CADUTA_PRESENTE: this.caduta_presente, CADUTA_NOTE: this.caduta_note, CADUTA_OGGETTI_PRESENTE: this.caduta_oggetti_presente,CADUTA_OGGETTI_NOTE: this.caduta_oggetti_note,
                SCIVOLAMENTO_PRESENTE: this.scivolamento_presente, SCIVOLAMENTO_NOTE: this.scivolamento_note,ELETTROCUZIONE_PRESENTE: this.elettrocuzione_presente, ELETTROCUZIONE_NOTE: this.elettrocuzione_note,
                TAGLI_ABRASIONI_PRESENTE: this.tagli_abrasioni_presente, TAGLI_ABRASIONI_NOTE: this.tagli_abrasioni_note, MECCANICO_PRESENTE: this.meccanico_presente, MECCANICO_NOTE: this.meccanico_note
            };
            console.log(`tab 4`);
            console.log(this.TAB4);
        },

        salvaTab5: function() {
            this.TAB5 = {
                RSPP_DATORE_EVIDENZE: this.rspp_datore_evidenze,
                RSPP_DATORE_EVIDENZE_FORMAZIONE: this.rspp_datore_evidenze_formazione, 
                RSPP_DATORE_MESE: this.rspp_datore_mese,
                RSPP_ESTERNO_EVIDENZE_FORMAZIONE: this.rspp_esterno_evidenze_formazione, 
                ADDETTI_ANTINCENDIO_EVIDENZE_FORMAZIONE: this.addetti_antincendio_evidenze_formazione, 
                ADDETTI_ANTINCENDIO_MESE: this.addetti_antincendio_mese,
                ADDETTI_SOCCORSO_EVIDENZE_FORMAZIONE: this.addetti_soccorso_evidenze_formazione, 
                ADDETTI_SOCCORSO_MESE: this.addetti_antincendio_mese,
                PREPOSTI_EVIDENZE_FORMAZIONE: this.preposti_evidenze_formazione, 
                PREPOSTI_MESE: this.preposti_mese,
                DIRIGENTI_EVIDENZE_FORMAZIONE: this.dirigenti_evidenze_formazione, 
                DIRIGENTI_MESE: this.dirigenti_mese,
                CARRELLI_ELEVATORI_EVIDENZE_FORMAZIONE: this.carrelli_elevatori_evidenze_formazione, 
                CARRELLI_ELEVATORI_MESE: this.carrelli_elevatori_mese,
                GRU_EVIDENZE_FORMAZIONE: this.gru_evidenze_formazione, 
                GRU_MESE: this.gru_mese,
                FORMAZIONE_LAVORATORI_EVIDENZE_FORMAZIONE: this.formazione_lavoratori_evidenze_formazione, 
                FORMAZIONE_LAVORATORI_FORMATI: this.formazione_lavoratori_formati, 
                FORMAZIONE_LAVORATORI_FORMARE: this.formazione_lavoratori_formare, 
                FORMAZIONE_LAVORATORI_MESE: this.formazione_lavoratori_mese,
                RISCHI_EVIDENZE_FORMAZIONE: this.rischi_evidenze_formazione,
                RISCHIO_LAVORATORI_FORMATI: this.rischio_lavoratori_formati, 
                RISCHIO_LAVORATORI_FORMARE: this.rischio_lavoratori_formare,
                RISCHIO_LAVORATORI_MESE: this.rischio_lavoratori_mese
            };
            console.log(`tab 5`);
            console.log(this.TAB5);
        },

        salvaTab6: function() {
            this.TAB6 = {
                ESTINTORI: this.estintori, VIE_FUGA: this.vie_fuga, MACCHINE_ATTREZZATURA: this.macchine_attrezzatura, DESTINAZIONE_USO_LOCALE: this.destinazione_uso_locale,
                CONTENITORI_PRODOTTI_CHIMICI: this.contenitori_prodotti_chimici, SERVIZI_IGENICI_DIVISI: this.servizi_igenici_divisi, SERVIZI_IGENICI_ANTIBAGNO:this.servizi_igenici_antibagno,
                AERAZIONE_NATURALE: this.aerazione_naturale, ILLUMINAZIONE_NATURALE: this.illuminazione_naturale, SCHERMATA_TENDAGGI: this.schermata_tendaggi, SCHERMATA_VENEZIANE: this.schermata_veneziane, ILLUMINAZIONE_ARTIFICIALE: this.illuminazione_artificiale, ANTIRIFLESSO: this.antiriflesso, SCALE_PARAPETTO: this.scale_parapetto,
                GRADINI_ANTISCIVOLO: this.gradini_antiscivolo, CORRIMANO: this.corrimano, SCALE_CONFORMI: this.scale_conformi, PARAPETTO: this.parapetto, INDICAZIONE_PORTATA_SCALE: this.indicazione_portata_scale, PRESENZA_SCALE: this.presenza_scale,
                SOPPALCHI_CONFORMI: this.soppalchi_conformi, SCAFFALATURE_FISSE: this.scaffalature_fisse, INDICAZIONE_PORTATA_SOPPALCHI: this.indicazione_portata_soppalchi, PRESENZA_PARACOLPI_BASE: this.presenza_paracolpi_base, NUMERO_ESTINTORI: this.numero_estintori, CONTROLLO_SEMESTRALE: this.controllo_semestrale, CASSETTA: this.cassetta,
                /*ANNO_CERTIFICAZIONE: this.anno_certificazione, PIANO_EMERGENZA: this.piano_emergenza, ANNO_PIANO_EMERGENZA: this.anno_piano_emergenza, PROVA_EVACUAZIONE_ANNUALE: this.prova_evacuazione_annuale,
                ANNO_PROVA_EVACUAZIONE_ANNUALE: this.anno_prova_evacuazione_annuale, REGISTRO_PIANI_EMERGENZA: this.registro_piani_emergenza, REGISTRO_PIANI_EMERGENZA_ANNO: this.registro_piani_emergenza_anno, PLANIMETRIA_LOCALI_DATA: this.planimetria_locali_data,
                PLANIMETRIA_LOCALI_NOTE: this.planimetria_locali_note, DICHIARAZIONE_CONFORMITA_ELETTRICO_DATA: this.dichiarazione_conformita_elettrico_data, DICHIARAZIONE_CONFORMITA_ELETTRICO_NOTE: this.dichiarazione_conformita_elettrico_note,
                DICHIARAZIONE_CONFORMITA_TERMICO_DATA: this.dichiarazione_conformita_termico_data, DICHIARAZIONE_CONFORMITA_TERMICO_NOTE: this.dichiarazione_conformita_termico_note, VERIFICA_PERIODICA_IMPIANTO_DATA: this.verifica_periodica_impianto_data,
                VERIFICA_PERIODICA_IMPIANTO_NOTE: this.verifica_periodica_impianto_note, AGIBILITA_DATA: this.agibilita_locali_data, AGIBILITA_LOCALI_NOTE: this.agibilita_locali_note */
            };
            console.log(`tab 6`);
            console.log(this.TAB6);
        },

        salvaTab7: function() {
            this.TAB7 = {
                CERTIFICATO_PREVENZIONE: this.certificato_prevenzione,
                ANNO_CERTIFICAZIONE: this.anno_certificazione,
                PIANO_EMERGENZA: this.piano_emergenza,
                ANNO_PIANO_EMERGENZA: this.anno_piano_emergenza,
                PROVA_EVACUAZIONE_ANNUALE: this.prova_evacuazione_annuale,
                ANNO_PROVA_EVACUAZIONE_ANNUALE: this.anno_prova_evacuazione_annuale,
                REGISTRO_PIANI_EMERGENZA: this.registro_piani_emergenza,
                REGISTRO_PIANI_EMERGENZA_ANNO: this.registro_piani_emergenza_anno,
                PLANIMETRIA_LOCALI_DATA: this.planimetria_locali_data,
                PLANIMETRIA_LOCALI_NOTE: this.planimetria_locali_note,
                DICHIARAZIONE_CONFORMITA_ELETTRICO_DATA: this.dichiarazione_conformita_elettrico_data,
                DICHIARAZIONE_CONFORMITA_ELETTRICO_NOTE: this.dichiarazione_conformita_elettrico_note,
                DICHIARAZIONE_CONFORMITA_TERMICO_DATA: this.dichiarazione_conformita_termico_data,
                DICHIARAZIONE_CONFORMITA_TERMICO_NOTE: this.dichiarazione_conformita_termico_note,
                VERIFICA_PERIODICA_IMPIANTO_DATA: this.verifica_periodica_impianto_data,
                VERIFICA_PERIODICA_IMPIANTO_NOTE: this.verifica_periodica_impianto_note,
                AGIBILITA_LOCALI_DATA: this.agibilita_locali_data,
                AGIBILITA_LOCALI_NOTE: this.agibilita_locali_note
            };
            console.log(`tab 7`);
            console.log(this.TAB7);
        },
        
        salvaTab8: function() {
            this.TAB8 = {
                LISTA_ATTREZZATURE: this.lista_attrezzature,
                LISTA_SOSTANZE_CHIMICHE: this.lista_sostanze_chimiche,
                LISTA_MANSIONI_DIPENDENTI: this.lista_mansioni_dipendenti
            };
            console.log(`tab 8`);
            console.log(this.TAB8);
        },

        salvaAllTab: function() {
            this.salvaTab1()
            this.salvaTab2()
            this.salvaTab3()
            this.salvaTab4()
            this.salvaTab5()
            this.salvaTab6()
            this.salvaTab7()
            this.salvaTab8()
        },

        salvaValoriDati: async function() {
            if (/*this.checkData()*/ true) {
                let errore = 0;
                let datiJSON = {TAB1: this.TAB1, TAB2: this.TAB2, TAB3: this.TAB3, TAB4: this.TAB4, TAB5: this.TAB5, TAB6: this.TAB6, TAB7: this.TAB7, TAB8: this.TAB8} //JSON.stringify(this.TAB2 + this.TAB3 + this.TAB4 + this.TAB5 + this.TAB6);
                let dati = {DATA: this.data, SEDE_OPERATIVA: this.sede_operativa, N_SOCI: this.n_soci, N_SOCI_LAVORATORI: this.n_soci_lavoratori, N_DIPENDENTI: this.n_dipendenti, INTERFERENZE: this.interferenze, 
                            DESCRIZIONE_ATTIVITA: this.descrizione_attivita, N_ORE_SETTIMANALI: this.n_ore_settimanali, DATORE_LAVORO: this.datore_lavoro, DATIJSON: datiJSON, TOKEN: this.TOKEN};
                console.log(dati);
                console.log(datiJSON);
                let salvaValori = [];

                await ChecklistServices.createChecklist(dati) 
                .then(response => { salvaValori = response.data})
                .catch( function (error) {
                    if(error.response.status == 401){
                        errore = error.response.status;
                }
                });
                if (errore == 401) {
                    let value = await Services.refreshTokenFunction();
                    if (value) { await this.salvaValoriDati(); }
                }
            }
        },

        motidicaValoriDati: async function() {
            if (this.checkData()) {
                let errore = 0;
                let datiJSON = {TAB1: this.TAB1, TAB2: this.TAB2, TAB3: this.TAB3, TAB4: this.TAB4, TAB5: this.TAB5, TAB6: this.TAB6, TAB7: this.TAB7, TAB8: this.TAB8} //JSON.stringify(this.TAB2 + this.TAB3 + this.TAB4 + this.TAB5 + this.TAB6);
                let dati = {DATA: this.data, SEDE_OPERATIVA: this.sede_operativa, N_SOCI: this.n_soci, N_SOCI_LAVORATORI: this.n_soci_lavoratori, N_DIPENDENTI: this.n_dipendenti, INTERFERENZE: this.interferenze, 
                            DESCRIZIONE_ATTIVITA: this.descrizione_attivita, N_ORE_SETTIMANALI: this.n_ore_settimanali, DATORE_LAVORO: this.datore_lavoro, DATIJSON: datiJSON};
                console.log(dati);
                console.log(datiJSON);
                let salvaValori = [];

                await ChecklistServices.updateChecklist(dati, this.id) 
                .then(response => { salvaValori = response.data})
                .catch( function (error) {
                    if(error.response.status == 401){
                        errore = error.response.status;
                }
                });
                if (errore == 401) {
                    let value = await Services.refreshTokenFunction();
                    if (value) { await this.salvaValoriDati(); }
                }
            }
        },

        loadDati: async function() {
            if(this.id == null)
                return
            else{
                let errore = 0;
                let salvaValori = [];

                await ChecklistServices.getDatiChecklist(this.id) 
                .then(response => { salvaValori = response.data})
                .catch( function (error) {
                    if(error.response.status == 401){
                        errore = error.response.status;
                }
                });
                if (errore == 401) {
                    let value = await Services.refreshTokenFunction();
                    if (value) { await this.salvaValoriDati(); }
                }
                this.riempiChecklist(salvaValori[0].VALUE)
            }
        },

        riempiChecklist: async function(salvaValori) {
            this.data = salvaValori.TAB1.DATA
            this.ditta = salvaValori.TAB1.DITTA
            this.n_sedi = salvaValori.TAB1.N_SEDI
            this.sede_operativa = salvaValori.TAB1.SEDE_OPERATIVA
            this.sede_legale = salvaValori.TAB1.SEDE_LEGALE
            this.n_soci = salvaValori.TAB1.N_SOCI
            this.n_soci_lavoratori = salvaValori.TAB1.N_SOCI_LAVORATORI
            this.n_dipendenti = salvaValori.TAB1.N_DIPENDENTI
            this.n_collaboratori = salvaValori.TAB1.N_COLLABORATORI
            this.subapp = salvaValori.TAB1.SUBAPP
            this.interferenze = salvaValori.TAB1.INTERFERENZE
            this.descrizione_attivita = salvaValori.TAB1.DESCRIZIONE_ATTIVITA
            this.n_ore_settimanali = salvaValori.TAB1.N_ORE_SETTIMANALI
            this.orario_notturno = salvaValori.TAB1.ORARIO_NOTTURNO
            this.orario_dalle = salvaValori.TAB1.ORARIO_DALLE
            this.orario_alle = salvaValori.TAB1.ORARIO_ALLE
            this.mansioni_dipendenti = salvaValori.TAB1.MANSIONI_DIPENDENTI
            this.note = salvaValori.TAB1.NOTE

            //TAB2
            this.datore_lavoro = salvaValori.TAB2.DATORE_LAVORO
            this.delegato_sicurezza = salvaValori.TAB2.DELEGATO_SICUREZZA
            this.data_delegato_sicurezza = salvaValori.TAB2.DATA_DELEGATO_SICUREZZA
            this.rspp_sig = salvaValori.TAB2.RSPP_SIG
            this.rspp_dl = salvaValori.TAB2.RSPP_DL
            this.medico_competente_dr = salvaValori.TAB2.MEDICO_COMPETENTE_DR
            this.medico_non_nominato = salvaValori.TAB2.MEDICO_NON_NOMINATO
            this.medico_da_nominare = salvaValori.TAB2.MEDICO_DA_NOMINARE
            this.medico_in_fase_nomina = salvaValori.TAB2.MEDICO_IN_FASE_NOMINA

            this.rls_sig = salvaValori.TAB2.RLS_SIG
            this.rls_non_nominato = salvaValori.TAB2.RLS_NON_NOMINATO
            this.rls_da_nominare = salvaValori.TAB2.RLS_DA_NOMINARE
            this.rls_in_fase_nomina = salvaValori.TAB2.RLS_IN_FASE_NOMINA

            this.soccorso_sig1 = salvaValori.TAB2.SOCCORSO_SIG1
            this.soccorso_nomina_del1 = salvaValori.TAB2.SOCCORSO_NOMINA_DEL1
            this.soccorso_sig2 = salvaValori.TAB2.SOCCORSO_SIG2
            this.soccorso_nomina_del2 = salvaValori.TAB2.SOCCORSO_NOMINA_DEL2
            this.antincendio_sig1 = salvaValori.TAB2.ANTINCENDIO_SIG1
            this.antincendio_nomina_del1 = salvaValori.TAB2.ANTINCENDIO_NOMINA_DEL1
            this.antincendio_sig2 = salvaValori.TAB2.ANTINCENDIO_SIG2
            this.antincendio_nomina_del2 = salvaValori.TAB2.ANTINCENDIO_NOMINA_DEL2
            this.preposto_sig = salvaValori.TAB2.PREPOSTO_SIG
            this.preposto_nomina_del = salvaValori.TAB2.PREPOSTO_NOMINA_DEL

            //TAB3
            this.dvr_evidenza = salvaValori.TAB3.DVR_EVIDENZA
            this.dvr_data_redazione = salvaValori.TAB3.DVR_DATA_REDAZIONE
            this.dvr_predisporre = salvaValori.TAB3.DVR_PREDISPORRE

            this.pos_evidenza = salvaValori.TAB3.POS_EVIDENZA
            this.pos_data_redazione = salvaValori.TAB3.POS_DATA_REDAZIONE
            this.pos_predisporre = salvaValori.TAB3.POS_PREDISPORRE

            this.duvri_evidenza = salvaValori.TAB3.DUVRI_EVIDENZA
            this.duvri_data_redazione = salvaValori.TAB3.DUVRI_DATA_REDAZIONE
            this.duvri_predisporre = salvaValori.TAB3.DUVRI_PREDISPORRE

            this.chimico_evidenza = salvaValori.TAB3.CHIMICO_EVIDENZA
            this.chimico_data_redazione = salvaValori.TAB3.CHIMICO_DATA_REDAZIONE
            this.chimico_predisporre = salvaValori.TAB3.CHIMICO_PREDISPORRE

            this.stress_evidenza = salvaValori.TAB3.STRESS_EVIDENZA
            this.stress_data_redazione = salvaValori.TAB3.STRESS_DATA_REDAZIONE
            this.stress_predisporre = salvaValori.TAB3.STRESS_PREDISPORRE

            this.incendio_evidenza = salvaValori.TAB3.INCENDIO_EVIDENZA
            this.incendio_data_redazione = salvaValori.TAB3.INCENDIO_DATA_REDAZIONE
            this.incendio_predisporre = salvaValori.TAB3.INCENDIO_PREDISPORRE

            this.atex_evidenza = salvaValori.TAB3.ATEX_EVIDENZA
            this.atex_data_redazione = salvaValori.TAB3.ATEX_DATA_REDAZIONE
            this.atex_predisporre = salvaValori.TAB3.ATEX_PREDISPORRE

            this.rumore_evidenza = salvaValori.TAB3.RUMORE_EVIDENZA
            this.rumore_data_redazione = salvaValori.TAB3.RUMORE_DATA_REDAZIONE
            this.rumore_predisporre = salvaValori.TAB3.RUMORE_PREDISPORRE

            this.vibrazione_evidenza = salvaValori.TAB3.VIBRAZIONE_EVIDENZA
            this.vibrazione_data_redazione = salvaValori.TAB3.VIBRAZIONE_DATA_REDAZIONE
            this.vibrazione_predisporre = salvaValori.TAB3.VIBRAZIONE_PREDISPORRE

            this.videoterminale_evidenza = salvaValori.TAB3.VIDEOTERMINALE_EVIDENZA
            this.videoterminale_data_redazione = salvaValori.TAB3.VIDEOTERMINALE_DATA_REDAZIONE
            this.videoterminale_predisporre = salvaValori.TAB3.VIDEOTERMINALE_PREDISPORRE

            this.amianto_evidenza = salvaValori.TAB3.AMIANTO_EVIDENZA
            this.amianto_data_redazione = salvaValori.TAB3.AMIANTO_DATA_REDAZIONE
            this.amianto_predisporre = salvaValori.TAB3.AMIANTO_PREDISPORRE

            this.biologico_evidenza = salvaValori.TAB3.BIOLOGICO_EVIDENZA
            this.biologico_data_redazione = salvaValori.TAB3.BIOLOGICO_DATA_REDAZIONE
            this.biologico_predisporre = salvaValori.TAB3.BIOLOGICO_PREDISPORRE
            this.cancerogeno_evidenza = salvaValori.TAB3.CANCEROGENO_EVIDENZA
            this.cancerogeno_data_redazione = salvaValori.TAB3.CANCEROGENO_DATA_REDAZIONE
            this.cancerogeno_predisporre = salvaValori.TAB3.CANCEROGENO_PREDISPORRE

            this.campi_el_evidenza = salvaValori.TAB3.CAMPI_EL_EVIDENZA
            this.campi_el_data_redazione = salvaValori.TAB3.CAMPI_EL_DATA_REDAZIONE
            this.campi_el_predisporre = salvaValori.TAB3.CAMPI_EL_PREDISPORRE
            this.movimentazione_evidenza = salvaValori.TAB3.MOVIMENTAZIONE_EVIDENZA
            this.movimentazione_data_redazione = salvaValori.TAB3.MOVIMENTAZIONE_DATA_REDAZIONE
            this.movimentazione_predisporre = salvaValori.TAB3.MOVIMENTAZIONE_PREDISPORRE
            this.radiazioni_evidenza = salvaValori.TAB3.RADIAZIONI_EVIDENZA
            this.radiazioni_data_redazione = salvaValori.TAB3.RADIAZIONI_DATA_REDAZIONE
            this.radiazioni_predisporre = salvaValori.TAB3.RADIAZIONI_PREDISPORRE

            this.lavoratrici_evidenza = salvaValori.TAB3.LAVORATRICI_EVIDENZA
            this.lavoratrici_data_redazione = salvaValori.TAB3.LAVORATRICI_DATA_REDAZIONE
            this.lavoratrici_predisporre = salvaValori.TAB3.LAVORATRICI_PREDISPORRE

            this.legionella_evidenza = salvaValori.TAB3.LEGIONELLA_EVIDENZA
            this.legionella_data_redazione = salvaValori.TAB3.LEGIONELLA_DATA_REDAZIONE
            this.legionella_predisporre = salvaValori.TAB3.LEGIONELLA_PREDISPORRE

            this.microclima_evidenza = salvaValori.TAB3.MICROCLIMA_EVIDENZA
            this.microclima_data_redazione = salvaValori.TAB3.MICROCLIMA_DATA_REDAZIONE
            this.microclima_predisporre = salvaValori.TAB3.MICROCLIMA_PREDISPORRE
            this.radiazioni_solari_evidenza = salvaValori.TAB3.RADIAZIONI_SOLARI_EVIDENZA
            this.radiazioni_solari_data_redazione = salvaValori.TAB3.RADIAZIONI_SOLARI_DATA_REDAZIONE
            this.radiazioni_solari_predisporre = salvaValori.TAB3.RADIAZIONI_SOLARI_PREDISPORRE

            this.covid_evidenza = salvaValori.TAB3.COVID_EVIDENZA
            this.covid_data_redazione = salvaValori.TAB3.COVID_DATA_REDAZIONE
            this.covid_predisporre = salvaValori.TAB3.COVID_PREDISPORRE

            //TAB4
            this.caduta_presente = salvaValori.TAB4.CADUTA_PRESENTE
            this.caduta_note = salvaValori.TAB4.CADUTA_NOTE
            this.caduta_oggetti_presente = salvaValori.TAB4.CADUTA_OGGETTI_PRESENTE
            this.caduta_oggetti_note = salvaValori.TAB4.CADUTA_OGGETTI_NOTE
            this.scivolamento_presente = salvaValori.TAB4.SCIVOLAMENTO_PRESENTE
            this.scivolamento_note = salvaValori.TAB4.SCIVOLAMENTO_NOTE
            this.elettrocuzione_presente = salvaValori.TAB4.ELETTROCUZIONE_PRESENTE
            this.elettrocuzione_note = salvaValori.TAB4.ELETTROCUZIONE_NOTE
            this.tagli_abrasioni_presente = salvaValori.TAB4.TAGLI_ABRASIONI_PRESENTE
            this.tagli_abrasioni_note = salvaValori.TAB4.TAGLI_ABRASIONI_NOTE
            this.meccanico_presente = salvaValori.TAB4.MECCANICO_PRESENTE
            this.meccanico_note = salvaValori.TAB4.MECCANICO_NOTE

            //TAB5
            this.rspp_datore_evidenze = salvaValori.TAB5.RSPP_DATORE_EVIDENZE
            this.rspp_datore_evidenze_formazione = salvaValori.TAB5.RSPP_DATORE_EVIDENZE_FORMAZIONE
            this.rspp_datore_mese = salvaValori.TAB5.RSPP_DATORE_MESE
            this.rspp_esterno_evidenze_formazione = salvaValori.TAB5.RSPP_ESTERNO_EVIDENZE_FORMAZIONE
            this.addetti_antincendio_evidenze_formazione = salvaValori.TAB5.ADDETTI_ANTINCENDIO_EVIDENZE_FORMAZIONE
            this.addetti_antincendio_mese = salvaValori.TAB5.ADDETTI_ANTINCENDIO_MESE
            this.addetti_soccorso_evidenze_formazione = salvaValori.TAB5.ADDETTI_SOCCORSO_EVIDENZE_FORMAZIONE
            this.addetti_antincendio_mese = salvaValori.TAB5.ADDETTI_SOCCORSO_MESE
            this.preposti_evidenze_formazione = salvaValori.TAB5.PREPOSTI_EVIDENZE_FORMAZIONE
            this.preposti_mese = salvaValori.TAB5.PREPOSTI_MESE
            this.dirigenti_evidenze_formazione = salvaValori.TAB5.DIRIGENTI_EVIDENZE_FORMAZIONE
            this.dirigenti_mese = salvaValori.TAB5.DIRIGENTI_MESE
            this.carrelli_elevatori_evidenze_formazione = salvaValori.TAB5.CARRELLI_ELEVATORI_EVIDENZE_FORMAZIONE
            this.carrelli_elevatori_mese = salvaValori.TAB5.CARRELLI_ELEVATORI_MESE
            this.gru_evidenze_formazione = salvaValori.TAB5.GRU_EVIDENZE_FORMAZIONE
            this.gru_mese = salvaValori.TAB5.GRU_MESE
            this.formazione_lavoratori_evidenze_formazione = salvaValori.TAB5.FORMAZIONE_LAVORATORI_EVIDENZE_FORMAZIONE
            this.formazione_lavoratori_formati = salvaValori.TAB5.FORMAZIONE_LAVORATORI_FORMATI
            this.formazione_lavoratori_formare = salvaValori.TAB5.FORMAZIONE_LAVORATORI_FORMARE
            this.formazione_lavoratori_mese = salvaValori.TAB5.FORMAZIONE_LAVORATORI_MESE
            this.rischi_evidenze_formazione = salvaValori.TAB5.RISCHI_EVIDENZE_FORMAZIONE
            this.rischio_lavoratori_formati = salvaValori.TAB5.RISCHIO_LAVORATORI_FORMATI
            this.rischio_lavoratori_formare = salvaValori.TAB5.RISCHIO_LAVORATORI_FORMARE
            this.rischio_lavoratori_mese = salvaValori.TAB5.RISCHIO_LAVORATORI_MESE

            //TAB6
            this.estintori = salvaValori.TAB6.ESTINTORI
            this.vie_fuga = salvaValori.TAB6.VIE_FUGA
            this.macchine_attrezzatura = salvaValori.TAB6.MACCHINE_ATTREZZATURA
            this.destinazione_uso_locale = salvaValori.TAB6.DESTINAZIONE_USO_LOCALE
            this.contenitori_prodotti_chimici = salvaValori.TAB6.CONTENITORI_PRODOTTI_CHIMICI
            this.servizi_igenici_divisi = salvaValori.TAB6.SERVIZI_IGENICI_DIVISI
            this.servizi_igenici_antibagno = salvaValori.TAB6.SERVIZI_IGENICI_ANTIBAGNO
            this.aerazione_naturale = salvaValori.TAB6.AERAZIONE_NATURALE
            this.illuminazione_naturale = salvaValori.TAB6.ILLUMINAZIONE_NATURALE
            this.schermata_tendaggi = salvaValori.TAB6.SCHERMATA_TENDAGGI
            this.schermata_veneziane = salvaValori.TAB6.SCHERMATA_VENEZIANE
            this.illuminazione_artificiale = salvaValori.TAB6.ILLUMINAZIONE_ARTIFICIALE
            this.antiriflesso = salvaValori.TAB6.ANTIRIFLESSO
            this.scale_parapetto = salvaValori.TAB6.SCALE_PARAPETTO
            this.gradini_antiscivolo = salvaValori.TAB6.GRADINI_ANTISCIVOLO
            this.corrimano = salvaValori.TAB6.CORRIMANO
            this.parapetto = salvaValori.TAB6.PARAPETTO
            this.indicazione_portata_scale = salvaValori.TAB6.INDICAZIONE_PORTATA_SCALE
            this.scale_conformi = salvaValori.TAB6.SCALE_CONFORMI
            this.soppalchi_conformi = salvaValori.TAB6.SOPPALCHI_CONFORMI
            this.presenza_scale = salvaValori.TAB6.PRESENZA_SCALE

            this.scaffalature_fisse = salvaValori.TAB6.SCAFFALATURE_FISSE
            this.indicazione_portata_soppalchi = salvaValori.TAB6.INDICAZIONE_PORTATA_SOPPALCHI
            this.presenza_paracolpi_base = salvaValori.TAB6.PRESENZA_PARACOLPI_BASE
            this.numero_estintori = salvaValori.TAB6.NUMERO_ESTINTORI
            this.controllo_semestrale = salvaValori.TAB6.CONTROLLO_SEMESTRALE
            this.cassetta = salvaValori.TAB6.CASSETTA

            //TAB7
            this.certificato_prevenzione = salvaValori.TAB7.CERTIFICATO_PREVENZIONE
            this.anno_certificazione = salvaValori.TAB7.ANNO_CERTIFICAZIONE
            this.piano_emergenza = salvaValori.TAB7.PIANO_EMERGENZA
            this.anno_piano_emergenza = salvaValori.TAB7.ANNO_PIANO_EMERGENZA
            this.prova_evacuazione_annuale = salvaValori.TAB7.PROVA_EVACUAZIONE_ANNUALE
            this.anno_prova_evacuazione_annuale = salvaValori.TAB7.ANNO_PROVA_EVACUAZIONE_ANNUALE
            this.registro_piani_emergenza = salvaValori.TAB7.REGISTRO_PIANI_EMERGENZA
            this.registro_piani_emergenza_anno = salvaValori.TAB7.REGISTRO_PIANI_EMERGENZA_ANNO
            this.planimetria_locali_data = salvaValori.TAB7.PLANIMETRIA_LOCALI_DATA
            this.planimetria_locali_note = salvaValori.TAB7.PLANIMETRIA_LOCALI_NOTE
            this.dichiarazione_conformita_elettrico_data = salvaValori.TAB7.DICHIARAZIONE_CONFORMITA_ELETTRICO_DATA
            this.dichiarazione_conformita_elettrico_note = salvaValori.TAB7.DICHIARAZIONE_CONFORMITA_ELETTRICO_NOTE
            this.dichiarazione_conformita_termico_data = salvaValori.TAB7.DICHIARAZIONE_CONFORMITA_TERMICO_DATA
            this.dichiarazione_conformita_termico_note = salvaValori.TAB7.DICHIARAZIONE_CONFORMITA_TERMICO_NOTE
            this.verifica_periodica_impianto_data = salvaValori.TAB7.VERIFICA_PERIODICA_IMPIANTO_DATA
            this.verifica_periodica_impianto_note = salvaValori.TAB7.VERIFICA_PERIODICA_IMPIANTO_NOTE
            this.agibilita_locali_data = salvaValori.TAB7.AGIBILITA_LOCALI_DATA
            this.agibilita_locali_note = salvaValori.TAB7.AGIBILITA_LOCALI_NOTE

            //TAB8
            this.lista_attrezzature = salvaValori.TAB8.LISTA_ATTREZZATURE
            this.lista_sostanze_chimiche = salvaValori.TAB8.LISTA_SOSTANZE_CHIMICHE
            this.lista_mansioni_dipendenti = salvaValori.TAB8.LISTA_MANSIONI_DIPENDENTI
        },

        main: async function() {
            this.salvaAllTab()
            if(this.id != null)
                this.motidicaValoriDati()
            else
                this.salvaValoriDati()
        },
    },
    
    mounted() {
        console.log(this.id);
        this.loadDati()
    }

};
</script>
<style scoped>
    .row-color:hover {
    background-color: #00467f53;
    }
    label {
        font-size: 16px;
    }

    .label-switch {
        position: relative;
        /* display: inline-block; */
        display: table-cell;
        padding-right: 10px;
        padding-left: 10px;
        font-size: 16px;
    }
    .switch {
        position: relative;
        /* display: inline-block; */
        display: table-cell;
        width: 55px;
        height: 34px;
    }

    .switch input { 
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

        .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 0px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }
    input:checked + .slider {
        background-color: #00467f;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #00467f;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }
    .slider.round:before {
        border-radius: 50%;
    }
</style>